import AuthClient, { authFetch } from "./AuthClient";

const AiAssistantApi = {
  getAiModels: async (cancelToken) => {
    const response = await AuthClient.get("ai/models", { cancelToken });
    return response.data.payload;
  },

  getConversationHistory: async (search, cancelToken) => {
    const params = search ? { search } : {};
    const response = await AuthClient.get("ai/history", {
      params,
      cancelToken,
    });
    return response.data.payload;
  },

  getConversationThread: async (threadId, cancelToken) => {
    const response = await AuthClient.get(`ai/history/${threadId}`, {
      cancelToken,
    });
    return response.data.payload;
  },

  postAiQuery: async (
    query,
    model,
    signal,
    { messages, threadId, dataScope } = {},
  ) => {
    const body = { query, model };

    // include previous context if there is any (this should be so when continuing a conversation)
    if (threadId != null) {
      body.threadId = threadId;
    }
    if (messages) {
      body.messages = messages;
    }
    if (dataScope) {
      body.dataScope = dataScope;
    }

    const response = await authFetch("ai/query", body, { signal });

    if (!response.ok) {
      let errorMessage = `HTTP error! status: ${response.status}`;
      try {
        const errorData = await response.json();
        if (errorData.messages?.length) {
          errorMessage = errorData.messages.join("; ");
        }
      } catch {
        // Fall back to generic status message
      }
      throw new Error(errorMessage);
    }

    return response;
  },

  submitFeedback: async (conversationId, rating, comments, cancelToken) => {
    const response = await AuthClient.post(
      `ai/feedback/${conversationId}`,
      { rating, comments },
      { cancelToken },
    );
    return response.data.payload;
  },
};

export default AiAssistantApi;
